// CareLogix™ ORACLE — Africa + Global AI Investment Intelligence API Client (Phase 19).
// Strictly additive — does not alter any prior client.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/oracle`;

const TOKEN_LS = "carelogix_oracle_token";
function authHeader() {
  try {
    const t = localStorage.getItem(TOKEN_LS);
    return t ? { Authorization: `Bearer ${t}` } : {};
  } catch {
    return {};
  }
}

const http = axios.create({ baseURL: API, timeout: 60000 });
http.interceptors.request.use((c) => {
  c.headers = { ...(c.headers || {}), ...authHeader() };
  return c;
});

export const africaApi = {
  status:        () => http.get("/africa/status"),
  countries:     () => http.get("/africa/countries"),
  pulse:         (preview = false) => http.get("/africa/pulse", { params: preview ? { preview: true } : {} }),
  country:       (code) => http.get(`/africa/country/${encodeURIComponent(code)}`),
  signals:       (limit = 20) => http.get("/africa/signals", { params: { limit } }),
  dailyBrief:    () => http.get("/africa/daily-brief"),
  formula:       () => http.get("/africa/score/formula"),
  computeScore:  (components) => http.post("/africa/score/compute", { components }),
  // watchlist
  watchlistGet:    () => http.get("/africa/watchlist"),
  watchlistAdd:    (body) => http.post("/africa/watchlist", body),
  watchlistDelete: (id) => http.delete(`/africa/watchlist/${encodeURIComponent(id)}`),
};

export const globalAiApi = {
  status:        () => http.get("/global-ai/status"),
  regions:       () => http.get("/global-ai/regions"),
  signalTypes:   () => http.get("/global-ai/signal-types"),
  pulse:         (preview = false) => http.get("/global-ai/pulse", { params: preview ? { preview: true } : {} }),
  region:        (code) => http.get(`/global-ai/region/${encodeURIComponent(code)}`),
  signals:       (limit = 24) => http.get("/global-ai/signals", { params: { limit } }),
  dailyBrief:    () => http.get("/global-ai/daily-brief"),
  formula:       () => http.get("/global-ai/score/formula"),
  computeScore:  (components) => http.post("/global-ai/score/compute", { components }),
  // watchlist
  watchlistGet:    () => http.get("/global-ai/watchlist"),
  watchlistAdd:    (body) => http.post("/global-ai/watchlist", body),
  watchlistDelete: (id) => http.delete(`/global-ai/watchlist/${encodeURIComponent(id)}`),
};
